import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import browser from 'Cloud/browser';
import { isPromoQuotaInAndroid } from 'reactApp/appHelpers/settingsHelpers';
import { SPACE_LIST } from 'reactApp/constants/spaceList';

export const isWopiForSafari = browser.isSafari() ? isFeature('wopi-safari') : true;
export const isWopiEnabled = isWopiForSafari && isFeature('wopi');
export const isWopiOldEnabled = isWopiForSafari && isFeature('wopi-old');

export const expFormats = isWopiForSafari && getFeature('myoffice-exp-formats');

export const attachTextFormats = getFeature('attach-text-formats') ?? [];

export const wopiFallbackConfig =
    isWopiForSafari &&
    (getFeature('wopi-fallback-config') || {
        hostReg: '^https:\\/\\/(?:docs\\-mo|docs\\-myoffice)\\.datacloudmail\\.ru',
        enableFallback: false,
        enableFallbackServiceError: false,
        enableTimeoutFallback: false,
        enableFallbackPostMsgError: false,
    });

export const wopiJsErrorsFallbackList = isWopiForSafari && (getFeature('wopi-js-errors-fallback-list') || []);
// Время фолбека для переключения с WOPI на AMR в секундах
export const wopiTimeoutFallbackTimeSec = isWopiForSafari && getFeature('wopi-timeout-fallback-time-sec');
export const isHashCalcLibWasm = getFeature('hash-lib')?.isWasm ?? 0;
export const isHashCalcLibCrypto = (getFeature('hash-lib')?.isCrypto && typeof window?.crypto?.subtle?.digest === 'function') ?? 0;
export const isDmrReactUrlEnabled = isFeature('ab-dmr-react');
export const isDmrReactUrlTouchEnabled = isFeature('ab-dmr-react-touch');
// DMR для реакт окна присылает неверную высоту, пока делаем коррекцию этого у себя
export const abReactDmrHeightFix = getFeature('ab-dmr-react')?.heightFix ?? 0;
export const isNewWebSearchUIEnabled = isFeature('new_search_UI');
// tempexp_SRCH-70037 start
export const isWebSearchContentEnabled = isNewWebSearchUIEnabled && isFeature('new_search_by_content');
// tempexp_SRCH-70037 end
// tempexp_SRCH-70925 start
export const isTouchSearchContentEnabled = isFeature('new_search_by_content_touch');
// tempexp_SRCH-70925 end
// tempexp_SRCH-70994 start
export const isNewWebSearchHistoryEnabled = isNewWebSearchUIEnabled && isFeature('new_search_query_history_web');
// tempexp_SRCH-70994 end
// tempexp_SRCH-70997 start
export const isTouchSearchHistoryEnabled = isFeature('new_search_query_history_touch');
// tempexp_SRCH-70997 end
// tempexp_SRCH-71849 start
export const isTouchSearchNewBackendEnabled = isFeature('new_search_handle_touch');
export const isWebSearchNewBackendEnabled = isNewWebSearchUIEnabled && isFeature('new_search_handle_web');
// tempexp_SRCH-71849 end

export const ebookDesktopConfig:
    | {
          exts: string[];
          timeout: number;
      }
    | undefined = getFeature('ebook-desktop-config');
export const ebookTouchConfig: typeof ebookDesktopConfig = getFeature('ebook-touch-config');
// tempexp_14979-start
export const isHideQuotaNewbieFeatureEnabled = isFeature('hide-quota-newbie');
// Нужно тестировать разную дефолную квоту до начала экспа. Поэтому мокаем через фичу.
export const defaultQuotaValueMockForQA = getFeature('default-quota-mock-qa') || false;
// tempexp_14979-end
/** CLOUDWEB-14535: ЕК. Фильтр по годам. Shift лет назад от текущего года для старых групп */
export const quotaCleanerOldGroupYear = getFeature('quota-cleaner-old-group-year') || 0;
/** CLOUDWEB-14948 Аб: Новый лп Единой квоты/страница подписок на таче */
export const isFeatureAbQuotaLandingTouch = getFeature('ab-quota-landing-touch') === 'b';
/** CLOUDWEB-15202 Аб: Лендинг /promocodes */
export const isFeatureAbPromocodesLanding = isFeature('ab-promocodes-landing');
/** CLOUDWEB-14877 Ovidius fallback */
export const isOvidiusFallback = isFeature('ovidius-fallback');
/** CLOUDWEB-13956 МойОфис. Поддержать совместимость функциональности фронтенда Облака по совместному редактированию */
export const isWopiCoEdit = isFeature('wopi-co-edit');
/** CLOUDWEB-15038 Развитие совместного редактирования. Эксперимент с изменением окна шаринга */
export const isModifiedSharingWindow = isFeature('modified-sharing-window');
/** CLOUDWEB-15029: МойОфис. Бизнес метрики. Интервал отправки аткуальности сессии в сек */
export const myOfficeSessionInterval = Number.parseInt(getFeature('myoffice-session-interval'));
/** CLOUDWEB-15029: МойОфис. Бизнес метрики. Включение по типу */
export const myofficeBMetricConfig = getFeature('myoffice-bmetric-config') || {};
/** B2BCLOUD-474: Включение просмотра временных аттачей-документов */
export const isTemporaryAttachView = isFeature('temporary-attach-view');
/** CLOUDWEB-15182 На странице Mail Space отсылать event в биллинг при просмотре тарифов, частота отправки события в мс */
export const sendStartEventTimer: number = getFeature('send-start-tariffs-event') || 0;
/** CLOUDWEB-15280 Поправить преимущества подписок
 * если это промо ек из приложения, то фича рабоать не должна */
export const isOnlyWebAdInTariffs = (!isPromoQuotaInAndroid && isFeature('only-web-ad-in-tariffs')) || false;
/** CLOUDWEB-15428 Выключаем бесконечную карусель на /subs и добавляем к ней дотсы  */
export const isNotInfiniteSubsCarousel = isFeature('not-infinite-subs-carousel') || false;
// Квота рекомендованного тарифа в списке тарифов
export const recommendedTariffQuota = getFeature('recommended-tariff-quota') || SPACE_LIST.gb_256;

// Урл и id для каптчи при отмене подписки
export const subscriptionCaptchaConfig: { url: string; captchaId: number } = getFeature('subscription-captcha-config') || {
    url: 'https://c.mail.ru/',
    captchaId: 5,
};
/** CLOUDWEB-15437: МойОфис. Метрики. White list рефереров */
export const myofficeBMetricProjectList = getFeature('myoffice-bmetric-project-list') || [];
/** CLOUDWEB-15488: Переименование файлов/папок в сетке по двойному клику на их название */
export const datalistInlineRenameEnabled = getFeature('datalist-inline-rename') || false;
